export enum HsCameraType {
  Perspective,
  Orthographic,
}
